const MONEY_FIELDS = [
    "last_recharge_folios",
    "folios_consumed",
    "folios_consumed_reception",
    "folios_balance",
    "recharge_notice",
    "folioRecharge"
];

export function fetchElectronicInvoicingService(state, data) {
    const normalized = { ...(data || {}) };

    MONEY_FIELDS.forEach(field => {
        if (normalized[field] === null || normalized[field] === undefined) {
            normalized[field] = 0;
        }
    });

    state.form = { ...state.form, ...normalized }
}


// WEBPACK FOOTER //
// ./src/modules/electronic-invoicing-services/mutations.js